import { applyRef } from '@packages/react/applyRef';
import { namedComponent } from '@packages/react/lib/named';
import React, { forwardRef, ReactElement } from 'react';
import { RoundedButton, RoundedButtonProps } from './rounded';

export interface PrimaryButtonProps extends Omit<RoundedButtonProps, 'elevation'> {
    elevation?: number;
    component?: any;

    [key: string]: any;
}

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: PrimaryButton
 * @date:  01.11.2019
 * @time:  06:54
 */
export const PrimaryButton = namedComponent<PrimaryButtonProps>(
    forwardRef((props, ref): ReactElement => {
        const rest = {
            elevation: 1,
            variant: 'contained' as any,
            color: 'primary',
            textColor: '#fff',
            radius: 3,
            ...props,
        };

        applyRef(rest, ref);

        return <RoundedButton {...rest} />;
    }),
    'PrimaryButton',
);
